import * as Yup from 'yup';
import { validationSchema as personProfileValidationSchema } from '../../components/personProfile/validation';

export const validationSchema = personProfileValidationSchema.shape({
  password: Yup.string()
    .required('enter_your_password')
    .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/, 'password_requirements_error'),
  confirmPassword: Yup.string()
    .required('confirm_your_password')
    .oneOf([Yup.ref('password')], 'password_matching_error'),
});
